import { jsx as e, jsxs as C } from "react/jsx-runtime";
import { memo as z, useEffect as H, useCallback as u, useMemo as Y } from "react";
import { useTranslation as W } from "react-i18next";
import { CREDIT_LIMITS_FORM_FIELDS as h, useCreditLimits as q, useCreditUtils as $, useCreditChoice as G, useFinancialPrograms as J, CreditType as T } from "@perxis-auto/credit-sdk";
import { debounce as K, markdownToHtml as Q, isDefined as X } from "@perxis-auto/shared";
import { Form as p, Row as E, Col as r, Switch as Z, Button as O, Icon as b, Disclaimer as ee } from "@perxis-auto/ui-kit";
import { APP as ie } from "../../../shared/config/app.js";
import { APP_EVENTS as y, APP_EVENT_BUTTONS as w } from "../../../shared/config/events.js";
import { eventService as P } from "../../../shared/lib/event/eventService.js";
import { FinancePrograms as te } from "../../FinancePrograms/ui/FinancePrograms.js";
import { FormControls as ne } from "../../FormControls/ui/FormControls.js";
const Fe = z(function({ onConfirm: d, onReset: c, formatters: M }) {
  const { t: f } = W(ie.name), [n] = p.useForm(), v = p.useWatch(h.type, n), {
    initialValues: x,
    requestId: k,
    isLoading: F,
    isHiddenTypeField: D,
    data: m
  } = q(), {
    handles: { handleValuesChange: I },
    formatters: { paymentTipFormatter: V }
  } = $({
    form: n
  }), {
    data: o,
    actions: { setFinancialProgram: _ }
  } = G(), { selected: s, data: g } = J(), B = !!(m && m.presentValue && m.downPayment && m.numberOfPeriods);
  H(() => {
    F || (n.resetFields(), N(n.getFieldsValue(), n.getFieldsValue()));
  }, [F, k]);
  const A = Y(
    () => K((i, l) => {
      if (!Object.keys(i).some(
        (t) => l[t] !== i[t]
      ))
        return;
      const L = (t, a) => X(a) ? t.endsWith("Amount") ? parseInt(String(a).replace(/\s+/g, ""), 10) : t === h.downPayment || t === h.residualPayment ? V(a) : a : a;
      for (const [t, a] of Object.entries(i))
        P.sendEvent(y.FormFieldValueChanged, {
          fieldId: t,
          value: L(t, a),
          previousValue: L(
            t,
            l[t]
          )
        });
    }, 200),
    [V]
  ), R = u(
    (i) => {
      i.some((S) => S.touched) && _({ program: null });
    },
    [_]
  ), U = u(
    (i) => {
      c == null || c(i), setTimeout(() => n.resetFields(), 0), P.sendEvent(y.ButtonClicked, {
        id: w.RESET_FORM
      });
    },
    [n, c]
  ), j = u(
    (i) => {
      s && (d == null || d(
        {
          choice: o,
          selectedFinancialProgram: s
        },
        i
      ), P.sendEvent(y.ButtonClicked, {
        id: w.CONFIRM_FORM
      }));
    },
    [o, d, s]
  ), N = u(
    (i, l) => (A(i, o), I(i, l)),
    [o, A, I]
  );
  return /* @__PURE__ */ e(
    p,
    {
      form: n,
      initialValues: x,
      onFieldsChange: R,
      onValuesChange: N,
      preserve: !1,
      children: /* @__PURE__ */ C(E, { gutter: [0, "vertical-yellow"], children: [
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ C(E, { gutter: [0, "vertical-green"], children: [
          !D && /* @__PURE__ */ e(r, { span: 24, className: "perxis-auto-credit-calc-switch", children: /* @__PURE__ */ e(
            p.Item,
            {
              name: h.type,
              normalize: (i) => i ? T.RESIDUAL_PAYMENT : T.ANNUITY,
              children: /* @__PURE__ */ e(
                Z,
                {
                  label: f("residualPayment"),
                  height: 32,
                  width: 54,
                  disabled: F,
                  checked: v === T.RESIDUAL_PAYMENT
                }
              )
            }
          ) }),
          /* @__PURE__ */ e(r, { span: 24, children: B && /* @__PURE__ */ e(ne, { formatters: M }) })
        ] }) }),
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(te, {}) }),
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ C(E, { gutter: [18, 18], className: "perxis-auto-credit-calc-buttons", children: [
          !!(g != null && g.length) && /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(
            O,
            {
              icon: /* @__PURE__ */ e(b, { name: "forward", size: 18 }),
              type: "primary",
              onClick: j,
              disabled: !o.program,
              children: f("confirm")
            }
          ) }),
          /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(O, { icon: /* @__PURE__ */ e(b, { name: "cross", size: 18 }), type: "ghost", onClick: U, children: f("reset") }) })
        ] }) }),
        s != null && s.description ? /* @__PURE__ */ e(r, { span: 24, className: "perxis-auto-credit-calc-disclaimer", children: /* @__PURE__ */ e(ee, { children: /* @__PURE__ */ e(
          "span",
          {
            dangerouslySetInnerHTML: {
              __html: Q(s.description)
            }
          }
        ) }) }) : null
      ] })
    }
  );
});
export {
  Fe as Form
};
